import { render, staticRenderFns } from "./gip-card.vue?vue&type=template&id=2f8b128f&scoped=true&v-if=gip&"
import script from "./gip-card.vue?vue&type=script&lang=ts&"
export * from "./gip-card.vue?vue&type=script&lang=ts&"
import style0 from "./gip-card.vue?vue&type=style&index=0&id=2f8b128f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b128f",
  null
  
)

export default component.exports